import { render, staticRenderFns } from "./BillingAccount.vue?vue&type=template&id=78c6fb68&scoped=true&"
import script from "./BillingAccount.vue?vue&type=script&lang=js&"
export * from "./BillingAccount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78c6fb68",
  null
  
)

export default component.exports